import { Box } from '@customerio/pluma-components/react';

/** Onboarding usage step. Placeholder — content lands with the usage step PR. */
export function OnboardingUsageStep() {
  return <Box data-testid="signup-step-onboarding-usage" />;
}
